module.exports = __webpack_public_path__ + "static/wpack/extracted/linkedin843bd51d7af095617a4df2b74629d609.svg";